import React, { useState } from "react";
import { motion } from "framer-motion";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const carouselImages = [
  "/images/display3.jpg",
  "/images/vistaimg1.jpg",
  "/images/vistaimg2.jpg",
];

const caseStudies = [
  {
    id: 1,
    image: "/images/case1.jpg",
    model: "Supermarket & C-Stores",
    name: "Efficiency, Visibility and Convenience",
    description:
      "Compact display units to optimise space, reduce costs, and boost sales.",
  },
  {
    id: 2,
    image: "/images/case2.jpg",
    model: "Supermarket & C-Stores",
    name: "World's Largest Autonomous Store",
    description:
      "Innovation, State-of-the-Art Technology, Energy Saving, and Seamless Experience and Operations, DSGO partners up with Retail Next Generation's New Store.",
  },
  {
    id: 3,
    image: "/images/choclatecase.jpg",
    model: "ChoclBakery & Pastry",
    name: "Showcasing Excellence",
    description:
      "Elegance and functionality to showcase the best of pâtisserie.",
  },
  {
    id: 4,
    image: "/images/case4.jpg",
    model: "Chocolate",
    name: " Incredible and Irresistible",
    description:
      "The best shopping experience and operational efficiency are the focus of DSGO solutions.",
  },
  {
    id: 5,
    image: "/images/case5.jpg",
    model: "Butchery & Charcuterie",
    name: " Retail in transformation",
    description:
      "Improving the grocery shopping experience every day.",
  },
  
  {
    id: 6,
    image: "/images/case6.jpg",
    model: "Supermarket & C-Stores",
    name: " Retail in transformation",
    description:
      "Improving the grocery shopping experience every day.",
  },

  {
    id: 7,
    image: "/images/case7.jpg",
    model: "Ice crea",
    name: " Perfect ice cream",
    description:
      "Perfect temperature, perfect flavours, every scoop is pure bliss.",
  },

  {
    id: 8,
    image: "/images/case8.jpg",
    model: "Bakery & Pastry",
    name: " 360 solutions",
    description:
      "Cakes, sandwiches, desserts, bread, drinks... optimal conservation with the best presentation",
  },

  {
    id: 9,
    image: "/images/case9.jpg",
    model: "Supermarket & C-Stores",
    name: " Spacious and airy stores",
    description:
      "The best shopping experience in a proximity store that breathes light and space.",
  },
  {
    id: 10,
    image: "/images/case10.jpg",
    model: "Supermarket & C-Stores",
    name: " Proximity Retailing",
    description:
      "The best shopping experience and operational efficiency are the focus of DSGO solutions.",
  },
  {
    id: 11,
    image: "/images/case11.jpg",
    model: "Supermarket & C-Stores",
    name: "   Every store has a story",
    description:
      "At the heart of any successful business is a great product, and at the heart of any great product is a great story.",
  },
  {
    id: 12,
    image: "/images/case12.jpg",
    model: "Supermarket & C-Stores",
    name: " Shopping experience in focus",
    description:
    "The best product presentation and service to delight your customers.",
  },

  {
    id: 13,
    image: "/images/case13.jpg",
    model: "Supermarket & C-Stores",
    name: " Campus Retail",
    description:
    "Shopping during lunchtime is easy and without waiting in line.",
  },
  {
    id: 14,
    image: "/images/case14.jpg",
    model: "Bakery & Pastry",
    name: " Capture customers' attention",
    description:
    "The key to attractively displaying your best pastry products.",
  },
  {
    id: 15,
    image: "/images/case15.jpg",
    model: "Bakery & Pastry",
    name: " 2-in-1, double opportunities",
    description:
    "Satisfied customers and more sales, success depends on choosing the right equipment..",
  },
  {
    id: 16,
    image: "/images/case16.jpg",
    model: "Supermarket & C-Stores",
    name: " Campus Retail",
    description:
    "Shopping during lunchtime is easy and without waiting in line.",
  },
 
  {
    id: 17,
    image: "/images/case18.jpg",
    model: "Supermarket & C-Stores",
    name: " Retail A to Z",
    description:
    "How to cope with consumers' expectations regarding product assortment and service.",
  },
  {
    id: 18,
    image: "/images/case19.jpg",
    model: "Bakery & Pastry",
    name: " Pink is Trendy",
    description:
    "How to cope with consumers' expectations regarding product assortment and service.",
  },


  {
    id: 19,
    image: "/images/case191.jpg",
    model: "Supermarket & C-Stores",
    name: " A hot shopping experience!",
    description:
    "Local stores where the versatility of DSGO solutions help you win over your customers.",
  },
  {
    id: 20,
    image: "/images/case20.jpg",
    model: "Supermarket & C-Stores",
    name: " Bolhão Market Oporto",
    description:
    "Oporto's most emblematic and historic market has reopened its doors.",
  },
  {
    id: 21,
    image: "/images/case21.jpg",
    model: "Take-Away",
    name: "Take-away is trendy",
    description:
    "Practical, convenient and always at hand, this concept is already part of everyday life.",
  },

  {
    id: 22,
    image: "/images/case22.jpg",
    model: "Modern food retail",
    name: "Supermarket & C-Stores",
    description:
    "Stores to always exceed their shoppers' expectations..",
  },
  {
    id: 23,
    image: "/images/case23.jpg",
    model: "Bakery & Pastry",
    name: "Appealing products",
    description:
    "Every shop is special, every project unique. Choosing the right display makes all the",
  },
  {
    id: 24,
    image: "/images/case24.jpg",
    model: "Supermarket & C-Stores",
    name: "Unique and impressive shops",
    description:
    "DSGO solutions for a shopping experience of excellence.",
  },
  {
    id: 25,
    image: "/images/case25.jpg",
    model: "Restaurant & Self-Service",
    name: "New food service brand",
    description:
    "Exciting shops and innovative projects attract and retain more customers!",
  },
  {
    id: 26,
    image: "/images/case26.jpg",
    model: "Coffee shop",
    name: "Shops with good energy",
    description:
    "Boosting businesses with help of DSGO solutions.",
  },
  {
    id: 27,
    image: "/images/case27.jpg",
    model: "Supermarket & C-Stores",
    name: "Perfect look and service",
    description:
    "Appealing products with the best presentation with the DSGO DAISY model.",
  },

  {
    id: 28,
    image: "/images/case28.jpg",
    model: "Butchery & Charcuterie",
    name: "Store renovation",
    description:
    "Renovated store improves customers' experience,",
  },
  {
    id: 29,
    image: "/images/case29.jpg",
    model: "Supermarket & C-Stores",
    name: "Organic retail",
    description:
    "Amazing product presentation in a newly opened Organic",
  },
  {
    id: 30,
    image: "/images/case30.jpg",
    model: "Coffee shop",
    name: "Impressive stores",
    description:
    "It's always good to return to good old habits, even better.",
  },
  {
    id: 31,
    image: "/images/case31.png",
    model: "Ice cream",
    name: "ICE CREAM NOW OR TO TAKE HOME?",
    description:
    "100% handmade and natural, trust in DSGO's specialist",
  },
  {
    id: 32,
    image: "/images/case32.jpg",
    model: "Coffee shop",
    name: "MORE EFFICIENT RETAIL",
    description:
    "Lower energy consumption and boost retail sales ",
  },
  {
    id: 33,
    image: "/images/case33.jpg",
    model: "Bakery & Pastry",
    name: "BAKERIES AT NEW CONSUMER JOURNEY",
    description:
    " As the bakery's business model continues to evolve,",
  },
  {
    id: 34,
    image: "/images/case37.jpg",
    model: "Supermarket & C-Stores",
    name: "CONVENIENCE RETAIL",
    description:
    " Fill up the car and something else, convenience in one place.",
  },
  {
    id: 35,
    image: "/images/case35.jpg",
    model: "Coffee shop",
    name: "CAFÉS WITH HISTORY",
    description:
    " The iconic Café A Brasileira in Lisbon, Portugal, chooses our.",
  },
  {
    id: 36,
    image: "/images/case36.jpg",
    model: " Bakery & Pastry",
    name: " TRADITIONAL BREAD",
    description:
    "The tradition of artisan bread is reborn in this new bakery.",
  },

  {
    id: 37,
    image: "/images/case38.jpg",
    model: " Bakery & Pastry",
    name: "SUCCESSFUL BAKERIES",
    description:
    "Bread and cakes always with the best presentation with.",
  },
  {
    id: 38,
    image: "/images/case388.jpg",
    model: "Coffee shop",
    name: " TIME FOR A SNACK",
    description:
    "Delicious sandwiches, beverages and salads to ready.",
  },
 
  {
    id: 39,
    image: "/images/case39.jpg",
    model: "Coffee shop",
    name: "THE STOPPING PLACE",
    description:
    "Petro stations choose DSGO solutions to offer a.",
  },
{
  id: 40,
  image: "/images/case40.jpg",
  model: "Supermarket & C-Stores",
  name: "NATURALLY EFFICIENT",
  description:
  "Efficient conservation and display of refrigerated and.",
},
{
  id: 41,
  image: "/images/case41.jpg",
  model: "Bakery & Pastry",
  name: "GOOD MORNING CANADA",
  description:
  "The truly Portuguese experience from Portugal to.",
},
{
  id: 42,
  image: "/images/case42.jpg",
  model: "Restaurant & Self-Service",
  name: "EXOTIC TASTES",
  description:
  "Fresh and delicious meals with FRESCO and UNITED food.",
},
{
  id: 43,
  image: "/images/case43.jpg",
  model: "Butchery & Charcuterie",
  name: "HIGH-QUALITY PRODUCTS",
  description:
  "A fine charcuterie and butcher store in Denmark where high.",
},

{
  id: 44,
  image: "/images/case44.png",
  model: "Fish & Seafood",
  name: "FRESH FISH & SEAFOOD",
  description:
  "Modern and efficient line of FUTURO display counters for.",
},
{
  id: 45,
  image: "/images/case45.png",
  model: "Supermarket & C-Stores",
  name: "BRAGA LOCAL FOOD MARKET",
  description:
  "New local food market Praça in Braga, Portugal just opened.",
},

{
  id: 46,
  image: "/images/case46.jpg",
  model: "Supermarket & C-Stores",
  name: "THE NEIGHBORHOOD STORE",
  description:
  "Convenience, flexibility and energy efficiency for all kind.",
},


{
  id: 47,
  image: "/images/case47.jpg",
  model: "Supermarket & C-Stores",
  name: "RENOVATED HYPERMARKET",
  description:
  "360° solutions for food retail with the new DSGO's.",
},
{
  id: 48,
  image: "/images/case48.png",
  model: "Supermarket & C-Stores",
  name: "THE FUTURE IS EFFICIENT & BIO",
  description:
  "FUTURO energy efficient multi decks range is the right choice.",
},
{
  id: 49,
  image: "/images/case49.jpg",
  model: "Supermarket & C-Stores",
  name: "A - Z RETAIL SOLUTIONS",
  description:
  "Reference store in Lisbon, Portugal, renovates its food.",
},

{
  id: 50,
  image: "/images/case50.png",
  model: "Supermarket & C-Stores",
  name: "THE FARM SHOP",
  description:
  "A local Farm Shop that chooses DSGO solutions to.",
},
{
  id: 51,
  image: "/images/case51.png",
  model: "Supermarket & C-Stores",
  name: "Ice cream",
  description:
  "Refreshing and delicious, no one can resist to the Ice-cream.",
},

{
  id: 52,
  image: "/images/case52.png",
  model: "Supermarket & C-Stores",
  name: "MORE PROMOTION, LESS ENERGY CONSUMPTION",
  description:
  "Performance, energy efficiency and maximum product impact.",
},

{
  id: 53,
  image: "/images/case53.png",
  model: "Coffee shop",
  name: "PERFECT PAUSE",
  description:
  "A Food Kiosk that becomes a mandatory stop point for.",
},
{
  id: 54,
  image: "/images/case54.jpg",
  model: "Supermarket & C-Stores",
  name: "IS TIME TO RESTART!",
  description:
  "In times of new rules, a new supermarket in Guimarães.",
},
{
  id: 55,
  image: "/images/case55.png",
  model: "Coffee shop",
  name: "TIME FOR A PAUSE?",
  description:
  "Travelling or just passing by, Convenience Store with KUBO.",
},
{
  id: 56,
  image: "/images/case56.png",
  model: "Bakery & Pastry",
  name: "A REAL SHOP RENOVATION",
  description:
  "Coffee-shop renovation in Braga, Portugal with KUBO.",
},
{
  id: 57,
  image: "/images/case57.png",
  model: "Supermarket & C-Stores",
  name: "RETAIL INNOVATION",
  description:
  "A new concept of food retail in Lisbon equipped with DSGO.",
},
{
  id: 58,
  image: "/images/case58.png",
  model: "Bakery & Pastry",
  name: "CHRISTMAS IS ALL AROUND!",
  description:
  "Modern solution for Customer Service in a recently opened.",
},
{
  id: 59,
  image: "/images/case59.png",
  model: "Bakery & Pastry",
  name: "IT’S IMPOSSIBLE TO RESIST!",
  description:
  "Second to none Pastry and Chocolates with the MINIMAL.",
},
{
  id: 60,
  image: "/images/case60.png",
  model: "Supermarket & C-Stores",
  name: "LAB STORE, INNOVATION IN FOOD RETAIL",
  description:
  "A Lab Store to discover new and emerging retail trends with.",
},
{
  id: 61,
  image: "/images/case61.png",
  model: "Take-Away",
  name: "GERMAN DELICACIES",
  description:
  "There’s a new culinary delight store with DAISY display cases.",
},
{
  id: 62,
  image: "/images/case62.png",
  model: "Ice cream",
  name: "WANNA A ICE-CREAM?",
  description:
  "Delicious and refreshing Ice-Cream with our solutions for.",
},
{
  id: 63,
  image: "/images/case63.png",
  model: "Restaurant & Self-Service",
  name: "MURCIA GASTROMARKET",
  description:
  "E-LINE display counters for display the best gastronomic.",
},
{
  id: 64,
  image: "/images/case64.png",
  model: "Bakery & Pastry",
  name: "SHINE LIKE JEWELS!",
  description:
  "High Quality Pastry and Chocolates in the centre of all.",
},
{
  id: 65,
  image: "/images/case65.png",
  model: "Supermarket & C-Stores",
  name: "MAXIMUM EFFICIENCY",
  description:
  "A brand of reference that now counts with DSGO's food.",
},
{
  id: 66,
  image: "/images/case66.png",
  model: "Coffee shop",
  name: "MADRID AIRPORT",
  description:
  "A reference airport with DSGO's grab'n'go solutions.",
},
{
  id: 67,
  image: "/images/case67.png",
  model: "Coffee shop",
  name: "FAST & EFFICIENT SERVICE",
  description:
  "DSGO`s professional furniture solutions for food.",
},
{
  id: 68,
  image: "/images/case68.png",
  model: "Butchery & Charcuterie",
  name: "NEW BUTCHERY",
  description:
  "A well know butchery shop in Guimarães - Portugal where.",
},
{
  id: 69,
  image: "/images/case69.png",
  model: "Restaurant & Self-Service",
  name: "GASTROMERCADO SEVILLE",
  description:
  "At the gastromercado Lonja del Barranco, E-LINE SLIM.",
},
{
  id: 70,
  image: "/images/case70.png",
  model: "Butchery & Charcuterie",
  name: "PRADO CHEESES",
  description:
  "The best cheeses and local products, that count with.",
},
{
  id: 71,
  image: "/images/case71.png",
  model: "Supermarket & C-Stores",
  name: "IMPRESSIVE SUPERMARKET!",
  description:
  "Pingo Doce Supermarket in Povoa de Varzim - close to.",
},
{
  id: 72,
  image: "/images/case72.png",
  model: "Take-Away",
  name: "WE LOVE HONG KONG!",
  description:
  "DSGO's exhibition and food service solutions in the Asian.",
},
];




const CaseStudies = () => {
  const itemsPerPage = 9;
  const [currentPage, setCurrentPage] = useState(1);
  
  const totalPages = Math.ceil(caseStudies.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = caseStudies.slice(startIndex, startIndex + itemsPerPage);

  return (
    <section className="bg-gray-50">
      {/* Carousel */}
      <div className="w-full relative">
        <Carousel autoPlay infiniteLoop showThumbs={false} showStatus={false} className="w-full">
          {carouselImages.map((img, index) => (
            <div key={index} className="w-full h-[500px] sm:h-[800px] relative">
              <img src={img} alt={`Carousel ${index + 1}`} className="w-full h-full object-cover rounded-lg" />
              <div className="absolute inset-0 flex items-center flex-col justify-center bg-black bg-opacity-30">
                <h2 className="text-4xl font-bold mb-4 md:text-9xl text-white">CASE STUDIES</h2>
              </div>
            </div>
          ))}
        </Carousel>
      </div>

      {/* Heading */}
      <div className="flex flex-col items-center justify-center text-center px-6 mt-12">
        <p className="text-3xl sm:text-6xl font-bold uppercase text-black">Real World Results</p>
        <p className="text-lg md:text-xl text-black max-w-3xl mt-6">Know more about stores and innovative concepts that trust on DSGO.</p>
      </div>
      
      {/* Grid Layout */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 mx-4 xl:px-8 2xl:px-32 mb-12 mt-12">
        {currentItems.map((study) => (
          <motion.div
            key={study.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="relative flex flex-col bg-white  overflow-hidden"
          >
            <div className="w-full h-60">
              <img src={study.image} alt={study.name} className="w-full h-full object-cover" />
            </div>
            <div className="p-6">
              <h3 className="text-xl text-gray-600">{study.model}</h3>
              <p className="text-xl font-bold">{study.name}</p>
              <p className="text-gray-700 mt-2">{study.description}</p>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Pagination Controls */}
      <div className="flex justify-center items-center space-x-4 mb-12">
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className="px-4 py-2 bg-gray-800 text-white rounded disabled:opacity-50"
        >
          Previous
        </button>
        <span className="text-lg font-bold">Page {currentPage} of {totalPages}</span>
        <button
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
          className="px-4 py-2 bg-gray-800 text-white rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </section>
  );
};

export default CaseStudies;

// import React from "react";
// import { motion } from "framer-motion";
// import { Carousel } from "react-responsive-carousel";
// import "react-responsive-carousel/lib/styles/carousel.min.css";

// const carouselImages = [
//   "/images/display3.jpg",
//   "/images/vistaimg1.jpg",
//   "/images/vistaimg2.jpg",
// ];

// const caseStudies = [
//   {
//     id: 1,
//     image: "/images/case1.jpg",
//     model: "Supermarket & C-Stores",
//     name: "Efficiency, Visibility and Convenience",
//     description:
//       "Compact display units to optimise space, reduce costs, and boost sales.",
//   },
//   {
//     id: 2,
//     image: "/images/case2.jpg",
//     model: "Supermarket & C-Stores",
//     name: "World's Largest Autonomous Store",
//     description:
//       "Innovation, State-of-the-Art Technology, Energy Saving, and Seamless Experience and Operations, DSGO partners up with Retail Next Generation's New Store.",
//   },
//   {
//     id: 3,
//     image: "/images/choclatecase.jpg",
//     model: "ChoclBakery & Pastry",
//     name: "Showcasing Excellence",
//     description:
//       "Elegance and functionality to showcase the best of pâtisserie.",
//   },
//   {
//     id: 4,
//     image: "/images/case4.jpg",
//     model: "Chocolate",
//     name: " Incredible and Irresistible",
//     description:
//       "The best shopping experience and operational efficiency are the focus of DSGO solutions.",
//   },
//   {
//     id: 5,
//     image: "/images/case5.jpg",
//     model: "Butchery & Charcuterie",
//     name: " Retail in transformation",
//     description:
//       "Improving the grocery shopping experience every day.",
//   },
  
//   {
//     id: 6,
//     image: "/images/case6.jpg",
//     model: "Supermarket & C-Stores",
//     name: " Retail in transformation",
//     description:
//       "Improving the grocery shopping experience every day.",
//   },

//   {
//     id: 7,
//     image: "/images/case7.jpg",
//     model: "Ice crea",
//     name: " Perfect ice cream",
//     description:
//       "Perfect temperature, perfect flavours, every scoop is pure bliss.",
//   },

//   {
//     id: 8,
//     image: "/images/case8.jpg",
//     model: "Bakery & Pastry",
//     name: " 360 solutions",
//     description:
//       "Cakes, sandwiches, desserts, bread, drinks... optimal conservation with the best presentation",
//   },

//   {
//     id: 9,
//     image: "/images/case9.jpg",
//     model: "Supermarket & C-Stores",
//     name: " Spacious and airy stores",
//     description:
//       "The best shopping experience in a proximity store that breathes light and space.",
//   },
//   {
//     id: 10,
//     image: "/images/case10.jpg",
//     model: "Supermarket & C-Stores",
//     name: " Proximity Retailing",
//     description:
//       "The best shopping experience and operational efficiency are the focus of DSGO solutions.",
//   },
//   {
//     id: 11,
//     image: "/images/case11.jpg",
//     model: "Supermarket & C-Stores",
//     name: "   Every store has a story",
//     description:
//       "At the heart of any successful business is a great product, and at the heart of any great product is a great story.",
//   },
//   {
//     id: 12,
//     image: "/images/case12.jpg",
//     model: "Supermarket & C-Stores",
//     name: " Shopping experience in focus",
//     description:
//     "The best product presentation and service to delight your customers.",
//   },

//   {
//     id: 13,
//     image: "/images/case13.jpg",
//     model: "Supermarket & C-Stores",
//     name: " Campus Retail",
//     description:
//     "Shopping during lunchtime is easy and without waiting in line.",
//   },
//   {
//     id: 14,
//     image: "/images/case14.jpg",
//     model: "Bakery & Pastry",
//     name: " Capture customers' attention",
//     description:
//     "The key to attractively displaying your best pastry products.",
//   },
//   {
//     id: 15,
//     image: "/images/case15.jpg",
//     model: "Bakery & Pastry",
//     name: " 2-in-1, double opportunities",
//     description:
//     "Satisfied customers and more sales, success depends on choosing the right equipment..",
//   },
//   {
//     id: 16,
//     image: "/images/case16.jpg",
//     model: "Supermarket & C-Stores",
//     name: " Campus Retail",
//     description:
//     "Shopping during lunchtime is easy and without waiting in line.",
//   },
//   {
//     id: 17,
//     image: "/images/case17.jpg",
//     model: "Bakery & Pastry",
//     name: " 360 solutions",
//     description:
//     "Cakes, sandwiches, desserts, bread, drinks... optimal conservation with the best presentation.",
//   },
//   {
//     id: 18,
//     image: "/images/case18.jpg",
//     model: "Supermarket & C-Stores",
//     name: " Retail A to Z",
//     description:
//     "How to cope with consumers' expectations regarding product assortment and service.",
//   },
//   {
//     id: 19,
//     image: "/images/case19.jpg",
//     model: "Bakery & Pastry",
//     name: " Pink is Trendy",
//     description:
//     "How to cope with consumers' expectations regarding product assortment and service.",
//   },
// ];

// const CaseStudies = () => {
//   return (
//     <section className="bg-gray-50">
//       {/* Carousel */}
//       <div className="w-full relative">
//   <Carousel
//     autoPlay
//     infiniteLoop
//     showThumbs={false}
//     showStatus={false}
//     className="w-full"
//   >
//     {carouselImages.map((img, index) => (
//       <div key={index} className="w-full h-[500px] sm:h-[800px] relative">
//         <img
//           src={img}
//           alt={`Carousel ${index + 1}`}
//           className="w-full h-full object-cover rounded-lg"
//         />
//         {/* Overlay Text */}
//         <div className="absolute inset-0 flex items-center flex-col justify-center bg-black bg-opacity-30">
//           <h2 className="text-4xl font-bold mb-4 md:text-9xl text-white">CASE STUDIES</h2>
//           {/* <p className=" text-xl text-slate-300"> Real World Results Innovative Refrigeration Solutions for Every Industry</p> */}
//         </div>
//       </div>
//     ))}
//   </Carousel>
// </div>


//       {/* Heading */}
//       <div className="flex flex-col items-center justify-center text-center px-6 mt-12">
//       <p className="text-3xl sm:text-6xl font-bold uppercase text-black">Real World Results Innovative Refrigeration Solutions for Every Industry</p>
//       <p className="text-lg md:text-xl text-black max-w-3xl mt-12 "> Know more about stores and innovative concepts that trust on DSGO for the success of its business. Challenge us!</p>
//       </div>
     
//       {/* Grid Layout */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-12 justify-center mx-4 xl:px-8 2xl:px-32 mb-12 mt-12">
//   {caseStudies.map((study) => (
//     <motion.div
//       key={study.id}
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.5, ease: "easeOut" }}
//       className="relative flex flex-col xl:w-[400px] 2xl:w-[400px]"
//     >
//       {/* Background Image */}
//       <div className="w-full  h-60">
//         <img
//           src={study.image}
//           alt={study.name}
//           className="w-full h-full object-cover"
//         />
//       </div>

//       {/* Text Content */}
//       <div className="flex-1 flex flex-col justify-between p-6 bg-white">
//         <h3 className="text-xl  text-gray-600">{study.model}</h3>
//         <p className="text-xl font-bold ">{study.name}</p>
//         <p className="text-gray-700 mt-2">{study.description}</p>
//       </div>
//     </motion.div>
//   ))}
// </div>


//     </section>
//   );
// };

// export default CaseStudies;
